export default __webpack_public_path__ + "static/media/tijo.5d7b2df4.png";